import * as React from 'react';
import {
    Create,
    Edit,
    EditButton,
    List,
    required,
    SelectInput,
    SimpleForm,
    TextField,
    TextInput
} from 'react-admin';
import AdminPagination from '../AdminPagination';
import AdminSelectableDatagrid from '../AdminSelectableDatagrid';

const zoneChoices = [
    { id: 'FR', name: 'France / Île-de-France' },
    { id: '971', name: 'Guadeloupe' },
    { id: '972', name: 'Martinique' },
];

const depositChoices = [
    { id: 'cheque', name: 'Chèque de caution' },
    { id: 'online', name: 'Caution en ligne' },
];

const IdentityForm = () => (
    <>
        <SelectInput
            source="zone_code"
            label="Zone du contrat"
            choices={zoneChoices}
            validate={required()}
            fullWidth
        />

        <TextInput
            source="name"
            label="Nom de l'identité"
            helperText="Exemple : Jénès Péyia Music Guadeloupe"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="company_name"
            label="Raison sociale"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="address"
            label="Adresse"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="phone"
            label="Téléphone"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="email"
            label="Email"
            type="email"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="siret"
            label="SIRET"
            validate={required()}
            fullWidth
        />

        <TextInput
            source="vat_number"
            label="N° TVA"
            validate={required()}
            fullWidth
        />

        <SelectInput
            source="deposit_method"
            label="Mode de dépôt de garantie"
            choices={depositChoices}
            defaultValue="cheque"
            validate={required()}
            fullWidth
        />
    </>
);

export const BoxContractIdentityList = (props) => (
    <List
        {...props}
        bulkActionButtons={false}
        perPage={20}
        pagination={<AdminPagination />}
        exporter={false}
    >
        <AdminSelectableDatagrid>
            <TextField source="zone_code" label="Zone" />
            <TextField source="name" label="Identité" />
            <TextField source="company_name" label="Raison sociale" />
            <TextField source="phone" label="Téléphone" />
            <TextField source="deposit_method" label="Dépôt de garantie" />
            <EditButton />
        </AdminSelectableDatagrid>
    </List>
);

export const BoxContractIdentityEdit = (props) => (
    <Edit {...props} mutationMode="optimistic" title="Identité du contrat">
        <SimpleForm redirect="list">
            <IdentityForm />
        </SimpleForm>
    </Edit>
);

export const BoxContractIdentityCreate = (props) => (
    <Create {...props} title="Nouvelle identité contrat">
        <SimpleForm redirect="list">
            <IdentityForm />
        </SimpleForm>
    </Create>
);
